import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyers } from '../data/content';
type Buyer = (typeof buyers)[number];
export function PurchasePopup() {
  const [buyer, setBuyer] = useState<Buyer | null>(null);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * buyers.length);
    let hideTimer: number;
    const show = () => {
      index = (index + 1) % buyers.length;
      setBuyer(buyers[index]);
      setMinutesAgo(1 + Math.floor(Math.random() * 9));
      hideTimer = window.setTimeout(() => setBuyer(null), 6000);
    };
    const firstTimer = window.setTimeout(show, 6000);
    const interval = window.setInterval(show, 16000);
    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  return <AnimatePresence data-id="element-41" data-mp="164egi9kqbgk9">
      {buyer && !dismissed && <motion.div initial={{
      x: -24,
      y: 12,
      opacity: 0
    }} animate={{
      x: 0,
      y: 0,
      opacity: 1
    }} exit={{
      x: -24,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 26
    }} className="fixed left-3 right-3 bottom-[104px] z-40 sm:right-auto sm:left-5 sm:bottom-5 sm:max-w-[330px]" role="status" aria-live="polite" data-id="element-42" data-mp="117fru6ju41tg">
          <div className="relative flex items-start gap-3 rounded-2xl border border-navy-100 bg-white px-3.5 py-3 shadow-[0_12px_30px_rgba(10,26,49,0.18)]" data-id="element-43" data-mp="i8tqcqkeo8p0">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-renal-50" data-id="element-44" data-mp="x2y9mbt4hwks">
              <CheckCircle2Icon className="h-5 w-5 text-renal-600" aria-hidden="true" data-id="element-45" data-mp="28kg6qsg77xyc" />
            </span>
            <div className="min-w-0 flex-1 pr-4" data-id="element-46" data-mp="23lmz3gnlf163">
              <p className="text-[12.5px] font-bold leading-snug text-navy-800" data-id="element-47" data-mp="23kv7si113plm">
                {buyer.name} acaba de comprar
              </p>
              <p className="text-[12px] leading-snug text-navy-700/80" data-id="element-48" data-mp="2fneapkvl70te">
                Ruta Enfermedad Renal™ — {buyer.city}, {buyer.country}
              </p>
              <p className="mt-0.5 text-[10.5px] font-semibold uppercase tracking-wide text-renal-600" data-id="element-49" data-mp="2knip95cxplgz">
                Hace {minutesAgo} minuto{minutesAgo === 1 ? '' : 's'}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded-full p-1 text-navy-400 transition-colors hover:bg-navy-50 hover:text-navy-700" data-id="element-50" data-mp="1rvz4vi4lq1de">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-51" data-mp="26p2lnnadcb32" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}